/****************** LOCAL SERVER ********************/
// export const API_URL = 'http://localhost:8888/squarenowreactwebapi/';
// export const FIN_API_URL = 'http://localhost:8888/squarenowfinanceapi/';
// export const EXPORT_API_URL = 'http://localhost:8888/squarenowreactwebapi/';
// export const API_URL = 'http://localhost:8888/squarenowapi-react/';
// export const FIN_API_URL = 'http://localhost:8888/squarenow-api-finance-react/';
// export const EXPORT_API_URL = 'http://localhost:8888/squarenowapi-react/';
 
/****************** DEVELOPEMENT SERVER ********************/
export const API_URL = 'https://dev.api.squarenow.in/';
export const FIN_API_URL = 'https://dev.fin.squarenow.in/';
 
export const S3_API_URL = 'https://adc-ecos.enlightcloud.com/8485-squarenow-qa/';
 
/****************** PRODUCTION SERVER ********************/
// export const API_URL = 'https://autoapi.squarenow.in/';
// export const FIN_API_URL = 'https://finnew.squarenow.co.in/';
 
// export const S3_API_URL = 'https://adc-ecos.enlightcloud.com/8485-squarenow-production/';